import { Component, OnInit, EventEmitter } from "@angular/core";
import { AguasService } from "../../servicios/aguas.service";
import { Observable, empty } from "rxjs";
import { BuscaTramite, MonitoreoFlujoTramiteInput, InfoTramiteInput, ServiciosConsultas, InfoTramite } from '../../entidades/entidades';
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { BuscaDetalleSolicitud, BuscaDetalleSolicitudInput } from "../../entidades/entidades";



@Component({
  selector: 'app-informacion',
  templateUrl: './informacion.component.html',
  styleUrls: ['./informacion.component.css']
})
export class InformacionComponent implements OnInit {
    
    public infoTramiteInput$ = new EventEmitter<InfoTramiteInput>();
    public  MonitoreoFlujoTramiteInput$ = new EventEmitter<MonitoreoFlujoTramiteInput>();
    
    MonitoreoFlujoTramiteInput:MonitoreoFlujoTramiteInput;
    infoTramiteInputProceso:InfoTramiteInput;
    muestraMensaje = new MuestraMensaje();
    conceptoSeleccionado: string = '';
    flagSolicitar: boolean = false;
    buscaTramite: BuscaTramite;

    public buscaDetalleSolicitud$: Observable<BuscaDetalleSolicitud>;
    public buscaDetalleSolicitudInput$ = new EventEmitter<BuscaDetalleSolicitudInput>();

    constructor(
        private aguasService: AguasService,
      
    ) { }

    ngOnInit() { }
    ngOnDestroy(): void { }

    async childMonitoreo(event) 
    {
        try { 
            this.flagSolicitar = false;
            if( (event[event.length - 1].estadoTramite == "COBRO") || 
            ((event.find(x => x.estadoTramite == "COBRO") == undefined) && event[event.length - 1].estadoTramite != "COBRO")) 
                {
                    this.flagSolicitar = true;
                }    
            
        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log("Paso por childTramite ");
        }
    }

    async childAguaBuscaCuentas(BuscaTramite: BuscaTramite) {
        try {
            this.buscaTramite = BuscaTramite;
            
            /*let infoTramiteInput1 = new InfoTramiteInput();
            infoTramiteInput1.numSolicitud = BuscaTramite.numSolicitud;
            this.infoTramiteInput$.emit(infoTramiteInput1);*/

            //Carga detalle adeudos
             this.MonitoreoFlujoTramiteInput=null;
             this.MonitoreoFlujoTramiteInput = new MonitoreoFlujoTramiteInput();
             this.MonitoreoFlujoTramiteInput.idSolicitud=BuscaTramite.idSolicitudDetalle;
             this.MonitoreoFlujoTramiteInput$.emit(this.MonitoreoFlujoTramiteInput);

            //Emite Para Info del Trámite
            this.infoTramiteInputProceso = null;
            this.infoTramiteInputProceso = new InfoTramiteInput();
            this.infoTramiteInputProceso.idSolicitud = BuscaTramite.id;
            this.infoTramiteInput$.emit(this.infoTramiteInputProceso);

            this.conceptoSeleccionado = BuscaTramite.concepto;

             
            let buscaDetalleSolicitudInput = new BuscaDetalleSolicitudInput();
            buscaDetalleSolicitudInput.id = BuscaTramite.id;
            this.buscaDetalleSolicitudInput$.emit(buscaDetalleSolicitudInput);


            
        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log("Paso por childTramite ");
        }
    }

    async childSolicitudDetalle(solicitud: BuscaTramite) {

        this.conceptoSeleccionado = solicitud.concepto;

        this.MonitoreoFlujoTramiteInput=null;
        this.MonitoreoFlujoTramiteInput = new MonitoreoFlujoTramiteInput();
        this.MonitoreoFlujoTramiteInput.idSolicitud=solicitud.id;
        this.MonitoreoFlujoTramiteInput$.emit(this.MonitoreoFlujoTramiteInput);
    }
    
    async childInfoTramite(infoTramite:  InfoTramite)
    {

        if(infoTramite.id)
        {
            debugger;
            this.childAguaBuscaCuentas(this.buscaTramite);
        }
    }
} 

